/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectSourceAwsOrganizationalUnitRequest {
  /**
  * ARN of the role Eon assumes to access the organizational unit in AWS.
  */
  'roleArn': string;
  /**
  * AWS Organizational Unit ID.
  */
  'providerOrganizationalUnitId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "roleArn",
      "baseName": "roleArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerOrganizationalUnitId",
      "baseName": "providerOrganizationalUnitId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectSourceAwsOrganizationalUnitRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

